/**
 * Gets an environment variable that is compatible with both Vite and Create React App.
 * @param key - The key of the environment variable to retrieve.
 * @returns - The value of the environment variable, or undefined if it does not exist.
 */
function getEnvVar(key) {
    const viteKey = `VITE_${key}`;
    const reactKey = `REACT_APP_${key}`;
    // If Vite-style envs are defined (browser or SSR), use them
    if (import.meta?.env && viteKey in import.meta.env) {
        return import.meta.env[viteKey];
    }
    // Else fallback to CRA/CRACO-style Node env (usually in server or CRA build)
    if (typeof process !== 'undefined' && process.env) {
        return process.env[reactKey];
    }
    // Not found
    return undefined;
}

export { getEnvVar };
//# sourceMappingURL=internalUtils.js.map
